import type { IBimRelationshipNode } from '@skystone/shared';
import { cn } from '@/lib/utils';
import { roleStyle } from '@/lib/bim-relationship-utils';

export interface BimTableCardProps {
  node: IBimRelationshipNode;
  isSelected: boolean;
  isDimmed: boolean;
  highlightedColumns: Set<string>;
  onSelect: (nodeId: string) => void;
}

export function BimTableCard({ node, isSelected, isDimmed, highlightedColumns, onSelect }: BimTableCardProps) {
  const style = roleStyle(node.role);

  return (
    <button
      type="button"
      data-testid={`bim-card-${node.id}`}
      onClick={() => onSelect(node.id)}
      className={cn(
        'flex h-full w-full flex-col overflow-hidden rounded-md border bg-card text-left shadow-sm transition-opacity',
        style.card,
        isSelected && 'ring-2 ring-primary ring-offset-1',
        isDimmed && 'opacity-30',
      )}
    >
      <div className={cn('flex items-center justify-between gap-2 px-2 py-1.5', style.header)}>
        <span className="truncate text-xs font-semibold">{node.tableName}</span>
        <span className={cn('rounded px-1.5 py-0.5 text-[10px] font-medium uppercase', style.chip)}>
          {node.role}
        </span>
      </div>
      <ul className="flex flex-1 flex-col gap-0.5 px-2 py-1">
        {node.keyColumns.length === 0 && (
          <li className="text-[11px] italic text-muted-foreground">no key fields</li>
        )}
        {node.keyColumns.map((column) => (
          <li
            key={column}
            className={cn(
              'truncate text-[11px] text-muted-foreground',
              highlightedColumns.has(column) && 'font-semibold text-foreground',
            )}
          >
            {column}
          </li>
        ))}
      </ul>
    </button>
  );
}
